var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.widgetLoaded),expression:"widgetLoaded"}],attrs:{"id":"printReady"}}),_c('DashboardGrid',{attrs:{"widgets":_vm.widgets,"col_num":4,"print":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }